import { ScreenMetadata } from '@types/index';

export class SchemaLoader {
  async loadFromURL(url: string): Promise<ScreenMetadata> {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to load schema: ${response.statusText}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Schema loading error:', error);
      throw error;
    }
  }

  async loadMultipleFromURL(urls: string[]): Promise<ScreenMetadata[]> {
    try {
      const results = await Promise.all(urls.map((url) => this.loadFromURL(url)));
      return results;
    } catch (error) {
      console.error('Multiple schema loading error:', error);
      throw error;
    }
  }

  loadFromJSON(json: string): ScreenMetadata {
    try {
      return JSON.parse(json);
    } catch (error) {
      console.error('JSON parsing error:', error);
      throw error;
    }
  }

  loadFromObject(obj: any): ScreenMetadata {
    return obj as ScreenMetadata;
  }

  async loadFromPublicSchema(schemaName: string): Promise<ScreenMetadata> {
    return this.loadFromURL(`/schemas/${schemaName}.json`);
  }
}

export const schemaLoader = new SchemaLoader();
